module.exports = __webpack_public_path__ + "static/media/facebook-white.fbfb8739.svg";